import Sparkle from "@/assets/icons/SparklePurple.svg";

interface IntelligenceButtonProps {
  isExpanded: boolean;
  isIntelligenceModalOpen: boolean;
}

const IntelligenceButton = ({
  isIntelligenceModalOpen = false,
  isExpanded,
}: IntelligenceButtonProps) => {
  return (
    <div
      className={`cursor-pointer ${
        isIntelligenceModalOpen
          ? "md:bg-[#FEF4ED] md:border md:border-[#FFD6B9] md:rounded-[6px] text-[#FF6500]"
          : "text-[#62636C] bg-white border-none"
      }
           ${isExpanded ? "md:flex-row" : "md:flex-col"}
          px-3 py-2 flex h-full md:justify-start justify-center flex-col gap-x-2 w-full items-center md:items-start transform ease-in-out transition-all`}
    >
      <div className="w-[20px]">
        <Sparkle />
      </div>
      {isExpanded && (
        <p
          className={`${
            isExpanded ? "opacity-100" : "w-[0px] opacity-0"
          }  whitespace-nowrap transform ease-in-out  transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%] flex gap-2.5 items-center`}
        >
          Intelligence
        </p>
      )}
    </div>
  );
};

export default IntelligenceButton;
